/**
 * Created by Denis Kuzin on 17 february 2022
 */

const ClansJoinRow = ClansRow.extend({
    ctor: function (row, options) {
        this._super(row, options);

        cleverapps.UI.onClick(this, () => {
            new ClanInformationWindow(row.data.clan);
        }, {
            interactiveScale: false
        });
    },

    createButton: function () {
        const styles = cleverapps.styles.ClansJoinRow;

        let text = Messages.get("Join");
        let tooltipText;
        if (this.row.data.clan.isFull()) {
            text = Messages.get("ClansJoinRow.full");
            tooltipText = Messages.get("ClanErrors.clanIsFull");
        } else if (!this.row.data.clan.isAppropriateByLevel()) {
            text = `${Messages.get("ClansJoinRow.level")} ${this.row.data.clan.requiredLevel}`;
            tooltipText = `${Messages.get("AddClanWindow.requiredLevel")} ${this.row.data.clan.requiredLevel}`;
        }

        const button = this.button = new cleverapps.UI.Button({
            type: styles.button.type,
            text,
            width: styles.button.width,
            height: styles.button.height,
            disabled: !this.row.data.clan.isAppropriate(),
            onClicked: function () {
                if (this.button) {
                    this.button.disable();
                }

                cleverapps.clans.join(this.row.data.clan.id);
            }.bind(this)
        });

        if (tooltipText) {
            cleverapps.tooltipManager.create(button, {
                text: tooltipText,
                location: cleverapps.UI.Tooltip.LOCATION_BELOW
            });
        }

        return button;
    },

    createScore: function () {
        const styles = cleverapps.styles.ClansJoinRow;

        const bg = cleverapps.UI.createScale9Sprite(bundles.clan_table.frames.clan_amount_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(styles.bg.width, styles.bg.height);

        if (this.row.data.clan.isFull()) {
            cleverapps.tooltipManager.create(bg, {
                text: Messages.get("ClanErrors.clanIsFull"),
                location: cleverapps.UI.Tooltip.LOCATION_BELOW
            });
        }

        const icon = new cc.Sprite(bundles.clan_table.frames.players_icon);
        icon.setAlignment(styles.icon);
        bg.addChild(icon);

        const text = cleverapps.UI.generateImageText(`${this.row.data.clan.membersCount}/${ClansConfig.MAX_SIZE}`, cleverapps.styles.FONTS.CLANS_ROW_SCORE_TEXT);
        text.fitTo(styles.text.width);
        text.setAlignment(styles.text);
        bg.addChild(text);

        return bg;
    }
});

cleverapps.styles.ClansJoinRow = {
    icon: {
        x: { align: "left", dx: 20 },
        y: { align: "center", dy: 0 }
    },

    text: {
        width: 140,
        x: { align: "right", dx: -20 },
        y: { align: "center", dy: 0 }
    },

    bg: {
        width: 235,
        height: 74
    },

    button: {
        width: 196,
        height: 75,
        type: cleverapps.styles.UI.Button.Images.button_green
    }
};